import { Link } from "react-router-dom";

export default function FloatingCTA() {
  return (
    <Link to="/contact" className="side-cta" aria-label="Get in touch">
      GET IN TOUCH
    </Link>
  );
}
